import client from './client';
import { _createAlert } from './apiUtils';
import { FullMiscEmployeeTaskWithEmployee } from '../interfaces/MiscEmployeeTaskInterface';

// Function to get miscellaneous tasks for a pay period
export const getMiscellaneousTasksForPayPeriod = async (payPeriodID: number): Promise<FullMiscEmployeeTaskWithEmployee[]> => {
    try {
        // Make the API request to fetch miscellaneous tasks for the pay period
        const response = await client.get('/admin/miscellaneousTasks/getForPayPeriod', {
            params: {
                payPeriodID: payPeriodID
            }
        });

        // Log the response data to the console
        console.log('Miscellaneous tasks response:', response.data);

        // Return the response data
        return response.data || [];

    } catch (error: any) {
        // Log any errors that occur during the fetch process
        console.error('Error fetching miscellaneous tasks:', error);
        
        // Trigger an alert with the error message
        _createAlert('Error fetching miscellaneous tasks:', error.message || 'Unknown error occurred');
        
        // Throw an error to indicate that fetching failed
        throw new Error('Failed to fetch miscellaneous tasks');
    }
};

// Function to update the super description for a miscellaneous task
export const updateMiscellaneousTaskSuperDescription = async (
    taskID: number,
    superDescription: string
): Promise<{ success: boolean; message?: string }> => {
    try {
        // Make the API request to update the super description
        const response = await client.put(`/admin/miscellaneousTasks/${taskID}`, {
            superDescription: superDescription
        });

        // Log the response data to the console
        console.log('Miscellaneous task updated successfully:', response.data);

        // Return the response data
        return response.data || { success: true };

    } catch (error: any) {
        // Log any errors that occur during the update process
        console.error('Error updating miscellaneous task:', error);
        
        // Extract error message from response if available
        const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
        
        // Return error response
        return { success: false, message: errorMessage };
    }
};

export const denyMiscellaneousTask = async (
    taskID: number,
    adminEmployeeID: number,
    superDescription: string
): Promise<{ success: boolean; message?: string }> => {
    try {
        const response = await client.post(`/admin/miscellaneousTasks/${taskID}/decline`, {
            adminEmployeeID,
            superDescription,
        });
        return response.data || { success: true };
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || error.message || 'Unknown error occurred';
        return { success: false, message: errorMessage };
    }
};

